'use client';

import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { SessionContext } from '@benzinga/session-context';
import { QuotesManager, Security, TickerDetail } from '@benzinga/quotes-manager';
import { safeUnwrapOrThrow } from '@benzinga/safe-await';

const FIVE_MINUTES = 5 * 60 * 1000;

export const TICKER_DETAILS_QUERY_KEY = 'tickerDetails' as const;

export const useTickerDetailsQuery = (symbol: Security) => {
  const session = useContext(SessionContext);

  return useQuery<TickerDetail | undefined>({
    enabled: !!symbol,
    queryFn: async () => {
      const result = await session.getManager(QuotesManager).getTickerDetails([symbol]);

      const detail = safeUnwrapOrThrow(result)?.result?.find(d => d.symbol === symbol);
      return detail;
    },
    queryKey: [TICKER_DETAILS_QUERY_KEY, symbol],
    staleTime: FIVE_MINUTES,
  });
};
